import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHeartCircleStack16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconHeartCircleStack16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.124 12.124a6 6 0 1 1-8.248-8.247 6 6 0 1 1 8.248 8.247m.768-1.985a5 5 0 0 0-7.031-7.03q.555-.11 1.139-.11a6 6 0 0 1 5.892 7.139M7 14A5 5 0 1 0 7 4a5 5 0 0 0 0 10M4.677 7.546c-.395.396-.441.742-.355 1.106.105.446.432.971.93 1.518a11 11 0 0 0 1.51 1.347q.126.095.238.175.112-.08.238-.175a11 11 0 0 0 1.51-1.347c.498-.547.825-1.072.93-1.518.086-.364.04-.71-.356-1.106-.257-.257-.427-.29-.503-.295-.095-.006-.222.022-.388.12-.167.1-.322.243-.443.375a3 3 0 0 0-.16.193l-.003.005a1 1 0 0 1-1.65 0l-.003-.005-.029-.038a3 3 0 0 0-.13-.155 2 2 0 0 0-.444-.374c-.167-.1-.294-.127-.388-.121-.077.005-.246.038-.504.295m3.03-.891c-.436.323-.707.724-.707.724s-.271-.4-.707-.724c-.57-.423-1.423-.716-2.323.184C1.374 9.436 7 12.9 7 12.9s5.626-3.463 3.03-6.06c-.9-.9-1.753-.607-2.323-.184"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHeartCircleStack16);
